declare const window: any
type Message = { action: string; payload: any }

export type NativePaymentPlatform = "ios" | "android"

export const isNative = window?.ReactNativeWebView !== undefined

let nativePlatform: NativePaymentPlatform | undefined

export const setNativePlatform = (platform: string) => {
  if (platform === "ios" || platform === "android") {
    nativePlatform = platform
  }
}

export const getNativePlatform = () => nativePlatform

// sends message to the app on mobile device
export const sendMessageToNative = (message: Message) => {
  if (window?.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify(message))
  }
}

const isPlatformMessage = (data: string) => {
  try {
    const message = JSON.parse(data)
    return message?.action === "platform"
  } catch {
    return false
  }
}

export const requestNativePlatform = (): Promise<
  NativePaymentPlatform | undefined
> => {
  const existing = getNativePlatform()
  if (existing) {
    return Promise.resolve(existing)
  }

  if (!isNative) {
    return Promise.resolve(undefined)
  }

  return new Promise((resolve) => {
    const handleMessage = (event: MessageEvent) => {
      if (!event?.data || !isPlatformMessage(event.data)) {
        return
      }

      try {
        const message = JSON.parse(event.data)
        setNativePlatform(message.payload)
      } catch {
        // ignore malformed payloads
      }

      cleanup()
      resolve(getNativePlatform())
    }

    const cleanup = () => {
      window.removeEventListener("message", handleMessage)
      document.removeEventListener("message", handleMessage)
      clearTimeout(timeoutId)
    }

    window.addEventListener("message", handleMessage)
    document.addEventListener("message", handleMessage)
    sendMessageToNative({ action: "get_platform", payload: "" })

    const timeoutId = setTimeout(() => {
      cleanup()
      resolve(getNativePlatform())
    }, 1000)
  })
}

// sends push notifications messages to deviceid of a device
export const sendPushNotification = async (expoPushToken: string) => {
  const message = {
    to: expoPushToken,
    sound: "default",
    title: "Push from React",
    body: "This is my expo push notification ",
  }

  alert(JSON.stringify(message))

  const r = await fetch("https://exp.host/--/api/v2/push/send", {
    method: "POST",
    headers: {
      //   host: "exp.host",
      accept: "application/json",
      "accept-encoding": "gzip, deflate",
      "content-type": "application/json",
    },
    body: JSON.stringify(message),
  })

  return r
}
